import { IconProps } from "./IconProps";

export function CheckCircle(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        d="M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16-7.2 16-16 16S0 24.8 0 16zm13.918 3.254l9.164-12.082L26 9.672l-11.668 15L6 16.34l2.5-2.5 5.418 5.414z"
        clipRule="evenodd"
      />
    </svg>
  );
}
